// extracted by mini-css-extract-plugin
export var orderDetails = "_kg-2";
export var orderImage = "_kg-1";
export var orderMeta = "_kg-3";
export var orderSummary = "_kg-0";
export var rightArrow = "_kg-4";